import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogsComponent } from './blogs/blogs.component';
import { CaseStudiesComponent } from './case-studies/case-studies.component';
import { InsightsRoutingModule } from './insights-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactivetoproactiveBlogComponent } from './reactivetoproactive-blog/reactivetoproactive-blog.component';
import { SmartManufacturingBlogComponent } from './smart-manufacturing-blog/smart-manufacturing-blog.component';
import { UnlockRemoteWorkBlogComponent } from './unlock-remote-work-blog/unlock-remote-work-blog.component';
import { OEEImprovementForManufacturingBlogComponent } from './oee-improvement-for-manufacturing-blog/oee-improvement-for-manufacturing-blog.component';
import { CelebratingWomenBlogComponent } from './celebrating-women-blog/celebrating-women-blog.component';
import { UnlockingtheproductivityBlogComponent } from './unlockingtheproductivity-blog/unlockingtheproductivity-blog.component';
import { ManufacturingTechnologyEfficiencyIndustry40BlogComponent } from './manufacturing-technology-efficiency-industry4-0-blog/manufacturing-technology-efficiency-industry4-0-blog.component';
import { TestcasesforecommerceBlogComponent } from './testcasesforecommerce-blog/testcasesforecommerce-blog.component';
import { ItstaffingsBlogComponent } from './itstaffings-blog/itstaffings-blog.component';
import { PiiUseCaseAiMlBlogComponent } from './pii-use-case-ai-ml-blog/pii-use-case-ai-ml-blog.component';
import { PlanningCloudCapacityBlogComponent } from './planning-cloud-capacity-blog/planning-cloud-capacity-blog.component';
import { PersonalizeAndMachineLearningBlogComponent } from './personalize-and-machine-learning-blog/personalize-and-machine-learning-blog.component';
import { MigrateCloudBlogComponent } from './migrate-cloud-blog/migrate-cloud-blog.component';
import { H1bVisaBlogComponent } from './h1b-visa-blog/h1b-visa-blog.component';
import { DigitalPartnerBlogComponent } from './digital-partner-blog/digital-partner-blog.component';
import { ChallengesManufacturingItIndustry40BlogComponent } from './challenges-manufacturing-it-industry-4-0-blog/challenges-manufacturing-it-industry-4-0-blog.component';

import { PostpandamicBlogComponent } from './postpandamic-blog/postpandamic-blog.component';
import { CloudCostOptimizationBlogComponent } from './cloud-cost-optimization-blog/cloud-cost-optimization-blog.component';
import { AiSolutionsforceecommerceBlogComponent } from './ai-solutionsforceecommerce-blog/ai-solutionsforceecommerce-blog.component';
import { AchievingHarmonyBlogComponent } from './achieving-harmony-blog/achieving-harmony-blog.component';
import { CybersecurityBlogComponent } from './cybersecurity-blog/cybersecurity-blog.component';
import { SensorManufacturingManagedServicesCasestudyComponent } from './sensor-manufacturing-managed-services-casestudy/sensor-manufacturing-managed-services-casestudy.component';
import { MachineLearningComponent } from './machine-learning/machine-learning.component';
import { SensorManufacturingCiCdCasestudyComponent } from './sensor-manufacturing-ci-cd-casestudy/sensor-manufacturing-ci-cd-casestudy.component';
import { AiMlUseCaseComponent } from './ai-ml-use-case/ai-ml-use-case.component';
import { GenAiPoweredTalentAquisitionComponent } from './gen-ai-powered-talent-aquisition/gen-ai-powered-talent-aquisition.component';
import { RfpChatbotImplementationComponent } from './rfp-chatbot-implementation/rfp-chatbot-implementation.component';
import { CloudDisasterRecoveryComponent } from './cloud-disaster-recovery/cloud-disaster-recovery.component';
import { AzureDeploymentsComponent } from './azure-deployments/azure-deployments.component';
import { DatacenterswithcloudComputingComponent } from './datacenterswithcloud-computing/datacenterswithcloud-computing.component';
import { GainCompetitiveAdvantageComponent } from './gain-competitive-advantage/gain-competitive-advantage.component';
import { ProductionPlanningComponent } from './production-planning/production-planning.component';
import { AiOnManufacturingChallengesComponent } from './ai-on-manufacturing-challenges/ai-on-manufacturing-challenges.component';
import { ECommerceInfluenceSupplyChainManagementComponent } from './e-commerce-influence-supply-chain-management/e-commerce-influence-supply-chain-management.component';
import { HumanMachineConversationsComponent } from './human-machine-conversations/human-machine-conversations.component';
import { LosingControlOfYourCloudComponent } from './losing-control-of-your-cloud/losing-control-of-your-cloud.component';



@NgModule({
  declarations: [
    BlogsComponent,
    CaseStudiesComponent,
    ReactivetoproactiveBlogComponent,
    SmartManufacturingBlogComponent,
    UnlockRemoteWorkBlogComponent,
    OEEImprovementForManufacturingBlogComponent,
    CelebratingWomenBlogComponent,
    UnlockingtheproductivityBlogComponent,
    ManufacturingTechnologyEfficiencyIndustry40BlogComponent,
    TestcasesforecommerceBlogComponent,
    ItstaffingsBlogComponent,
    PiiUseCaseAiMlBlogComponent,
    PlanningCloudCapacityBlogComponent,
    PersonalizeAndMachineLearningBlogComponent,
    MigrateCloudBlogComponent,
    DigitalPartnerBlogComponent,
    ChallengesManufacturingItIndustry40BlogComponent,
    CloudCostOptimizationBlogComponent,
    PostpandamicBlogComponent,
    H1bVisaBlogComponent,
    AiSolutionsforceecommerceBlogComponent,
    AchievingHarmonyBlogComponent,
    CybersecurityBlogComponent,
    SensorManufacturingManagedServicesCasestudyComponent,
    MachineLearningComponent,
    SensorManufacturingCiCdCasestudyComponent,
    AiMlUseCaseComponent,
    GenAiPoweredTalentAquisitionComponent,
    RfpChatbotImplementationComponent,
    CloudDisasterRecoveryComponent,
    AzureDeploymentsComponent,
    DatacenterswithcloudComputingComponent,
    GainCompetitiveAdvantageComponent,
    ProductionPlanningComponent,
    AiOnManufacturingChallengesComponent,
    ECommerceInfluenceSupplyChainManagementComponent,
    HumanMachineConversationsComponent,
    LosingControlOfYourCloudComponent
    
  ], schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  imports: [
    CommonModule,
    InsightsRoutingModule,
    BrowserModule,
    BrowserAnimationsModule
  ]
})
export class InsightsModule { }
